module.exports = __webpack_public_path__ + "static/media/19.613caccc.svg";